import { useEntity } from 'components';
import type { TableColumns } from '@ff-it/ui';
import { Box } from '@ff-it/ui';
import type { ReactNode } from 'react';
import type { ProductKind } from 'types';
import type { OutletOrServiceCategoryProduct } from './types';
import type { ProductListRow } from './productListColumns';
import { getProductListColumns } from './productListColumns';

function ProductOrInheritedCategory(product: OutletOrServiceCategoryProduct): ReactNode {
  const { item } = useEntity<OutletOrServiceCategoryProduct>();
  if (product.category) {
    return product.category.name;
  }
  if (item.category) {
    return (
      <Box color="gray500" title="Inherited from outlet or service category">
        <em>{item.category.name}</em>
      </Box>
    );
  }
  return null;
}

const categoryColumns: TableColumns<OutletOrServiceCategoryProduct> = [
  {
    content: 'Category',
    key: 'category.id',
    width: 250,
    render: (product: OutletOrServiceCategoryProduct) => <ProductOrInheritedCategory {...product} />,
  },
];

/**
 * Product-index columns. Shared product summaries are followed by type-owned
 * columns and route-specific details.
 */
export function getProductColumns(
  typeColumns?: TableColumns<OutletOrServiceCategoryProduct>,
  onOpen?: (product: OutletOrServiceCategoryProduct) => void,
  kind?: ProductKind,
): TableColumns<ProductListRow<OutletOrServiceCategoryProduct>> {
  return getProductListColumns<OutletOrServiceCategoryProduct>({
    onOpen,
    kind,
    afterProductColumns: [...(typeColumns ?? []), ...categoryColumns],
  });
}
